import { z } from 'zod';
import { FirestoreTimestamp } from './common.schema.js';
// --- Types ---
export var PlanId;
(function (PlanId) {
    PlanId["FREE"] = "free";
    PlanId["EDUCATOR"] = "educator";
    PlanId["PSYCHOLOGIST"] = "psychologist";
    PlanId["SCHOOL"] = "school";
    PlanId["ACADEMY"] = "academy";
    PlanId["PRO"] = "pro";
    PlanId["SMALL_ONE_TIME"] = "small_one_time";
    PlanId["LARGE_ONE_TIME"] = "large_one_time";
})(PlanId || (PlanId = {}));
export var TransactionType;
(function (TransactionType) {
    TransactionType["PURCHASE"] = "purchase";
    TransactionType["USAGE"] = "usage";
    TransactionType["REFUND"] = "refund";
    TransactionType["EXPIRATION"] = "expiration";
    TransactionType["ADMIN_ADJUSTMENT"] = "admin_adjustment";
    TransactionType["TRANSFER_IN"] = "transfer_in";
    TransactionType["TRANSFER_OUT"] = "transfer_out";
})(TransactionType || (TransactionType = {}));
// --- Schemas ---
export const SubscriptionSchema = z.object({
    plan_id: z.nativeEnum(PlanId),
    plan_name: z.string(),
    credits_remaining: z.number().nonnegative(),
    credits_total: z.number().nonnegative(),
    usage_lifetime: z.number().nonnegative(),
    monthly_image_quota: z.number().nullable().optional(),
    cost_per_image: z.number().nullable().optional(),
    rate_limit_req_per_min: z.number().nullable().optional(),
    renewal_date: FirestoreTimestamp,
    purchase_date: FirestoreTimestamp,
    is_active: z.boolean(),
    stripe_subscription_id: z.string().optional(),
    payment_method: z.string().optional(),
    currency: z.string().default('USD')
});
export const CreditLedgerEntrySchema = z.object({
    transaction_id: z.string().uuid().optional(), // Optional on creation
    transaction_type: z.nativeEnum(TransactionType),
    credits_delta: z.number(),
    credits_before: z.number(),
    credits_after: z.number(),
    timestamp: FirestoreTimestamp,
    description: z.string(),
    plan_id: z.string().optional(),
    expiration_date: FirestoreTimestamp.optional(),
    related_image_ids: z.array(z.string()).optional(),
    related_email: z.string().email().optional()
});
